module.exports = __webpack_public_path__ + "static/buehne_technologien-d58b69a8ddf7d8fce8da16670803a309.svg";